module.exports = __webpack_public_path__ + "img/Attack_ultimate fire tornado.6890c526.png";